/**
 * AgentSocketContext — shares one useAgentSocket() instance across the
 * dashboard tree so we never open more than one WS per tab.
 * Phase 13 R4 #284.
 */

import { createContext, useContext, type ReactNode } from "react";
import { useAgentSocket, type UseAgentSocketReturn } from "./useAgentSocket";

const AgentSocketContext = createContext<UseAgentSocketReturn | null>(null);

export function AgentSocketProvider({ children }: { children: ReactNode }) {
  const value = useAgentSocket();
  return (
    <AgentSocketContext.Provider value={value}>
      {children}
    </AgentSocketContext.Provider>
  );
}

export function useAgentSocketContext(): UseAgentSocketReturn {
  const ctx = useContext(AgentSocketContext);
  if (!ctx) {
    throw new Error(
      "useAgentSocketContext must be used inside <AgentSocketProvider>",
    );
  }
  return ctx;
}
